/**
 * The HUD's Place button: toggles placement mode (Analysis and Loader, full
 * profile only). Enabled once the network is loaded and the globe engine is up
 * (LoaderGlobe imports Cesium lazily, so the engine can arrive after the data).
 * It takes a row of its own in the top-left cluster: on the 1280 px default
 * viewport a third pill in the first row runs under the top-right scene controls.
 */
import { MapPinPlus } from 'lucide-react';
import { TextButton } from '@/components/ui/primitives';
import { useAwareness } from '../awareness/store';
import { useLoader } from '../store';
import { usePlacement } from './store';
import { usePlaceAvailable } from './usePlaceAvailable';

export function PlaceButton() {
  const available = usePlaceAvailable();
  const active = usePlacement((s) => s.active);
  const toggle = usePlacement((s) => s.toggle);
  const datasetReady = useLoader((s) => s.datasetStatus === 'ready');
  const engineMounted = useAwareness((s) => s.engineMounted);
  const ready = datasetReady && engineMounted;
  if (!available) return null;
  return (
    <div className="flex basis-full">
      <div className="pointer-events-auto flex items-center rounded-full border border-hairline bg-raised/85 px-1 py-1 backdrop-blur">
        <TextButton
          active={active}
          aria-pressed={active}
          disabled={!ready}
          onClick={toggle}
          title={active ? 'Cancel placement (Esc)' : 'Place an antenna on the globe and re-run the what-if'}
          className="flex items-center gap-1"
        >
          <MapPinPlus className="h-3.5 w-3.5" />
          Place
        </TextButton>
      </div>
    </div>
  );
}
